/* eslint-disable */
import { createStyles, Theme, withStyles } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import React, { Component } from "react";
import { connect } from "react-redux";
import BsTemplates from "../../components/component-questionnaire/Configurations/BsTemplates";
import LogoConfiguration from "../../components/component-questionnaire/Configurations/LogoConfiguration";
import EmailTemplateConfiguration from "../../components/component-questionnaire/Configurations/EmailTemplateConfiguration";
import InitialContactContractTemplateConfiguration from "../../components/component-questionnaire/Configurations/InitialContactContractTemplateConfiguration";
import EngagementTemplateConfiguration from "../../components/component-questionnaire/Configurations/EngagementTemplateConfiguration";
import ModuleConfiguration from "../../components/component-questionnaire/Configurations/ModuleConfiguration";
import PropertiesConfiguration from "../../components/component-questionnaire/Configurations/PropertiesConfiguration";
import PartyImports from "../../components/component-questionnaire/Configurations/PartyImports";
import ConventionTemplateConfiguration from "../../components/component-questionnaire/Configurations/ConventionTemplateConfiguration";
import MifidTemplateConfiguration from "../../components/component-questionnaire/Configurations/MifidTemplateConfiguration";
import Bandeau from "../../components/component-questionnaire/Configurations/Bandeau";
import HelpCenterClient from "../../components/component-questionnaire/Configurations/HelpCenterClient";
import TransferTemplates from "../../components/component-questionnaire/Configurations/TransferTemplates";
import Internationalisation from "../../components/component-questionnaire/Configurations/Internationalisation";
import SecTemplateConfiguration from "../../components/component-questionnaire/Configurations/SecTemplateConfiguration";
import FcaTemplateConfiguration from "../../components/component-questionnaire/Configurations/FcaTemplateConfiguration";
import LsfinTemplateConfiguration from "../../components/component-questionnaire/Configurations/LsfinTemplateConfiguration";
import FAQSyncConfiguration from "../../components/component-questionnaire/Configurations/FAQSyncConfiguration";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    downloadBS: {
      margin: "20px",
    },
    dropzoneEmail: {},
    previewChip: {
      width: "100px",
    },
  });
class ClientConfiguration extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  randomizeColors() {
    return `#${Math.random().toString(16).slice(2, 8)}`;
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.root}>
          <LogoConfiguration />
          <ModuleConfiguration />
          <BsTemplates />
          <TransferTemplates />
          <ConventionTemplateConfiguration />
          <EngagementTemplateConfiguration />
          <MifidTemplateConfiguration />
          <SecTemplateConfiguration />
          <FcaTemplateConfiguration />
          <LsfinTemplateConfiguration />
          <InitialContactContractTemplateConfiguration />
          <EmailTemplateConfiguration />
          <PropertiesConfiguration />
          <PartyImports />
          <Bandeau />
          <HelpCenterClient />
          <Internationalisation/>
          <FAQSyncConfiguration />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(ClientConfiguration)));
